<template>
  <div class="notification-management">
    <el-card shadow="never">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-input v-model="searchTitle" placeholder="搜索标题" clearable class="filter-input" @keyup.enter.native="handleSearch" />
            <el-select v-model="searchLeaderId" placeholder="创作者ID" clearable filterable class="filter-input-id" @change="handleSearch">
              <el-option v-for="l in leaders" :key="l.id" :label="l.id + ' - ' + (l.nickname || '')" :value="l.id" />
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
          </div>
          <div class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增公告</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>

      <el-table v-else :data="list" border stripe v-loading="loading" row-key="id">
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="leaderId" label="创作者ID" width="100" align="center" />
        <el-table-column prop="title" label="标题" min-width="180" show-overflow-tooltip />
        <el-table-column prop="content" label="内容" min-width="260" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="创建时间" width="170" align="center" />
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" center append-to-body>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item v-if="isEdit" label="创作者" prop="leaderId">
          <el-select v-model="form.leaderId" placeholder="请选择创作者" filterable>
            <el-option v-for="l in leaders" :key="l.id" :label="l.id + ' - ' + (l.nickname || '')" :value="l.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-else label="创作者" prop="leaderIds">
          <div class="leader-select-wrap">
            <el-select v-model="form.leaderIds" placeholder="请选择创作者（可多选）" filterable multiple collapse-tags class="leader-select">
              <el-option v-for="l in leaders" :key="l.id" :label="l.id + ' - ' + (l.nickname || '')" :value="l.id" />
            </el-select>
            <el-button type="text" size="small" @click="toggleSelectAll">
              {{ isAllSelected ? '取消全选' : '全选创作者' }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model.trim="form.title" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model.trim="form.content" type="textarea" :rows="5" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del } from '@/utils/http'

export default {
  name: 'NotificationManagement',
  data() {
    return {
      list: [],
      loading: false,
      error: '',
      searchTitle: '',
      searchLeaderId: '',
      leaders: [],
      pagination: { page: 1, pageSize: 10, total: 0 },
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: { leaderId: null, leaderIds: [], title: '', content: '' },
      rules: {
        leaderId: [{ required: true, message: '请选择创作者', trigger: 'change' }],
        leaderIds: [{ type: 'array', required: true, message: '请至少选择一位创作者', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑公告' : '新增公告'
    },
    isAllSelected() {
      return this.leaders.length > 0 && this.form.leaderIds.length === this.leaders.length
    }
  },
  mounted() {
    this.fetchLeaders()
    this.fetchList()
  },
  methods: {
    async fetchLeaders() {
      try {
        const result = await get('/admin/users', { role: 1, page: 1, pageSize: 500 })
        const data = result.data || {}
        this.leaders = Array.isArray(data.users) ? data.users : []
      } catch (e) {
        this.leaders = []
      }
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = { page: this.pagination.page, pageSize: this.pagination.pageSize }
        if (this.searchTitle) params.title = this.searchTitle
        if (this.searchLeaderId) params.leaderId = this.searchLeaderId
        const result = await get('/admin/notification/list', params)
        const data = result.data || {}
        this.list = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.error = e.message || '加载失败'
        this.list = []
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    refreshList() {
      this.searchTitle = ''
      this.searchLeaderId = ''
      this.pagination.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    },
    handleAdd() {
      this.isEdit = false
      this.editId = null
      this.form = { leaderId: null, leaderIds: [], title: '', content: '' }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.form.leaderIds = []
      } else {
        this.form.leaderIds = this.leaders.map(l => l.id)
      }
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = {
        leaderId: row.leaderId,
        leaderIds: [],
        title: row.title,
        content: row.content
      }
      this.dialogVisible = true
    },
    buildPayload() {
      if (this.isEdit) {
        return {
          leaderId: this.form.leaderId,
          title: this.form.title,
          content: this.form.content
        }
      }
      return {
        leaderIds: this.form.leaderIds,
        title: this.form.title,
        content: this.form.content
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()
      } catch {
        return
      }
      const payload = this.buildPayload()
      try {
        if (this.isEdit) {
          await put(`/admin/notification/${this.editId}`, payload)
        } else {
          await post('/admin/notification', payload)
        }
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该公告吗？', '提示', { type: 'warning' })
        await del(`/admin/notification/${row.id}`)
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {
        if (e !== 'cancel') this.$message.error(e.message || '删除失败')
      }
    }
  }
}
</script>

<style scoped>
.leader-select-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.leader-select {
  flex: 1;
}
</style>
